import React, { useEffect, useState } from "react";
import { useNavigate, Link  } from "react-router-dom"; 
import heroImage from "./../../../assets/images/hero-image.jpg";
import "./advancedhair.css"

function Hair() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // For unique navigation (treatment groups)
  const [activeTab, setActiveTab] = useState("GFC");
  const navigate = useNavigate();

  useEffect(() => {
    const steps = document.querySelectorAll('.hc-process-step');
    steps.forEach((step, index) => {
      step.style.setProperty('--index', index);
      step.style.opacity = '1';
    });
  }, []);

  return (
    <div className="hc-wrapper">
      <div className="hc-treatment-tabs">
        {["GROHAIR", "PRP",  "GFC","STM", "Laser"].map((tab) => (
          <div 
            key={tab} 
            className={`hc-treatment-tab ${activeTab === tab ? "hc-active" : ""}`}
            onClick={() => {
              setActiveTab(tab);
              // Navigate using a single slash (e.g., /hc)
              navigate(`/home/${tab.toLowerCase()}`) // Correct path format
            }}
          >
            {tab} Treatment
          </div>
        ))}
      </div>
      <section 
        className="hc-hero" 
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`
        }}
      >
        <div className="hc-hero-content">
          <h1 className="hc-hero-title">Advanced Gro Hair Treatment</h1>
          <p className="hc-hero-text">Experience Revolutionary Gro Hair Therapy</p>
         <Link to="/bookconsultation"  style={{ textDecoration: "none" }} className="hc-cta-button"> Book Consultation</Link>
        </div>
      </section>

      {/* Unique Treatment Navigation Tabs */}
      

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
        <div className="hc-treatment-nav">
            <h2>Revitalize Your Hair with Our Advanced Treatments</h2>
            <p className="hc-nav-description">
              From growth factor enhancements to exclusive hc therapies, each treatment is engineered to kickstart your natural hair regrowth.
            </p>
            <ul>
            <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps  in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
                
              </li>
   <li className="hc-active">
                <strong>Growth Factor Therapy</strong>
                <p>Stimulate hair follicles & helps  in hair regrowth .</p>
                <ul className="hc-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>Enrich with Biotin , Zinc , Minerals and other Vitamins</li>
                </ul>

              </li>
              <li>
                <strong>PRP Therapy</strong>
                <p>Restore your hair naturally by plasma rich protein therapy.</p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>
              
              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Based on plant poly peptides </li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="hc-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced specialists.
            </p>
            <p className="hc-treatment-extra-info">
              Book a consultation today to create your personalized treatment plan.
            </p>

          </div>

          <div className="hc-treatment-content">
            <h3>Growth Factor Treatment</h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src="https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?q=80"
                  alt="Growth Factor Treatment Process"
                  className="hc-main-treatment-image"
                />
                <div className="hc-treatment-gallery">
                  <img
                    src="https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80"
                    alt="Before and After Results"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80"
                    alt="Treatment Procedure"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80"
                    alt="Advanced Equipment"
                  />
                </div>
              </div>

              <div className="hc-treatment-description">
                <h4>Revolutionary Hair Growth Technology</h4>
                <div className="hc-treatment-intro">
                  <span className="hc-highlight-tag">Advanced Treatment</span>
                  <p className="hc-lead-text">
                    Experience the future of hair restoration with our FDA-approved Growth Factor Treatment.
                  </p>
                </div>

                <div className="hc-key-benefits">
                  <h5>How It Transforms Your Hair</h5>
                  <p>
                    Our scientifically proven treatment utilizes advanced growth factors and natural proteins to:
                  </p>
                  <ul>
                    <li>
                      <span className="hc-benefit-icon">🔬</span>
                      <strong>Stimulate hair Follicles</strong>
                      <p>Reactivates sleeping hair follicles for new growth</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">📈</span>
                      <strong>Increase Hair Density</strong>
                      <p>Up to 40% improvement in hair thickness</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">🌱</span>
                      <strong>Natural Hair Growth</strong>
                      <p>Promotes sustainable, natural-looking results</p>
                    </li>
                    <li>
                      <span className="hc-benefit-icon">💪</span>
                      <strong>Strengthen Existing Hair</strong>
                      <p>Reduces breakage and improves hair quality</p>
                    </li>
                  </ul>
                </div>

                <div className="hc-treatment-highlights">
                  <div className="hc-highlight-box">
                    <h5>Success Rate</h5>
                    <p>95%</p>
                    <span className="hc-subtitle">Satisfied Clients</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Treatment Time</h5>
                    <p>60 mins</p>
                    <span className="hc-subtitle">Per Session</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Recovery</h5>
                    <p>min to max</p>
                    <span className="hc-subtitle">depends upon person to person </span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Result</h5>
                    <p>6-10 sessions</p>
                    <span className="hc-subtitle">for visible results</span>
                  </div>
                </div>
                

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                      <button className="hc-book-treatment-btn">
                        Schedule Your Free Consultation
                        <span className="hc-btn-icon">→</span>
                      </button>
                    </Link>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="hc-benefits-section">
        <div className="hc-benefits-header">
          <span className="hc-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura</h2>
          <p className="hc-section-subtitle">
            Transforming lives through innovative hair restoration solutions
          </p>
        </div>

        <div className="hc-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "Cutting-Edge Technology",
              desc: "H-Cura leverages advanced growth factor technology and FDA-approved treatments to ensure optimal hair restoration results.",
              features: [
                "Latest Medical Innovation",
                "Proven Clinical Results",
                "Safe & Effective",
              ],
            },
            {
              icon: "👨‍⚕",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists bring decades of experience in advanced hair restoration techniques.",
              features: [
                "Certified Specialists",
                "Ongoing Training",
                "Dedicated Care Team",
              ],
            },
            {
              icon: "🎯",
              title: "Personalized Treatment",
              desc: "Every H-Cura treatment plan is tailored to your unique hair type, condition, and desired outcomes.",
              features: [
                "Custom Solutions",
                "Regular Monitoring",
                "Adaptive Care Plans",
              ],
            },
            {
              icon: "✨",
              title: "Natural Results",
              desc: "Experience transformative results that look and feel completely natural, boosting your confidence.",
              features: [
                "Lasting Results",
                "Natural Appearance",
                "High Success Rate",
              ],
            },
            {
              icon: "🛡",
              title: "Safety First Approach",
              desc: "H-Cura prioritizes your safety with stringent protocols and state-of-the-art facilities.",
              features: [
                "Medical-Grade Facility",
                "Sterile Environment",
                "Safety Protocols",
              ],
            },
            {
              icon: "💯",
              title: "Proven Track Record",
              desc: "Join thousands of satisfied clients who have experienced the H-Cura difference in hair restoration.",
              features: [
                "95% Success Rate",
                "10000+ Happy Clients",
                "Outstanding Reviews",
              ],
            },
          ].map((benefit, index) => (
            <div className="hc-benefit-card" key={index}>
              <div className="hc-benefit-icon">{benefit.icon}</div>
              <div className="hc-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="hc-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="hc-process-section" id="process">
        <div className="hc-process-header">
          <span className="hc-process-tag">Our Process</span>
          <h2>Your Journey to Fuller Hair with H-Cura</h2>
          <p className="hc-process-subtitle">
            Experience our comprehensive 4-step approach to hair restoration
          </p>
        </div>

        <div className="hc-process-timeline">
          {[
            {
              step: "01",
              title: "Comprehensive Consultation",
              desc: "Begin your transformation with a detailed assessment by our expert trichologists.",
              details: [
                "Advanced scalp analysis",
                "Hair loss pattern evaluation",
                "Medical history review",
                "Treatment expectations discussion",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Personalized Treatment Design",
              desc: "Receive a custom-tailored treatment plan designed specifically for your needs.",
              details: [
                "Growth factor concentration optimization",
                "Treatment schedule planning",
                "Expected timeline discussion",
                "Lifestyle recommendations",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Advanced Treatment Session",
              desc: "Experience H-Cura's state-of-the-art growth factor therapy.",
              details: [
                "Sterile environment preparation",
                "Growth factor application",
                "Scalp stimulation therapy",
                "Comfort-focused procedure",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Ensure optimal results with our dedicated follow-up program.",
              details: [
                "Progress monitoring",
                "Treatment adjustments",
                "Maintenance guidelines",
                "Long-term care planning",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="hc-process-step" key={index}>
              <div className="hc-step-container">
                <div className="hc-step-number-container">
                  <div className="hc-step-number">{process.step}</div>
                  <div className="hc-step-icon">{process.icon}</div>
                </div>
                <div className="hc-step-content">
                  <h3>{process.title}</h3>
                  <p className="hc-step-description">{process.desc}</p>
                  <ul className="hc-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="hc-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>
      
    </div>
  );
}

export default Hair;